type Subscription<T> = (args: T | any) => void;

export function createStorage<StoredValueType extends any>(
  key: string,
  defaultValue: any = null
) {
  const subscriptions = new Set<Subscription<StoredValueType>>();

  function subscribe(subscriber: Subscription<StoredValueType>) {
    subscriptions.add(subscriber);

    return () => {
      subscriptions.delete(subscriber);
    };
  }

  function get(): StoredValueType {
    const item = localStorage.getItem(key);
    return item ? item : defaultValue;
  }

  function set(value: StoredValueType) {
    subscriptions.forEach((sub) => sub(value));
    return localStorage.setItem(key, JSON.stringify(value));
  }

  function remove() {
    subscriptions.forEach((sub) => sub(defaultValue));
    localStorage.removeItem(key);
  }

  return {
    get,
    set,
    remove,
    subscribe,
  };
}